import { EUserPosition } from '../types/user';

// Display order for position pickers; not the same as EUserPosition's declaration order.
export const userPositions: ReadonlyArray<EUserPosition> = [
  EUserPosition.Stammpersonal,
  EUserPosition.Facharzt,
  EUserPosition.Oberarzt,
  EUserPosition.Chefarzt,
];
